import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    generalBranchAll: [],
    generalBranch: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "name",
    sortOrder: "asc",
};

const generalBranchSlice = createSlice({
    name: "generalBranch",
    initialState,
    reducers: {
        setGeneralBranchAll: (state, action) => {
            state.generalBranchAll = action.payload;
        },
        setGeneralBranch: (state, action) => {
            state.generalBranch = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
});

export const { 
    setGeneralBranchAll, 
    setGeneralBranch, 
    setCurrentPage, 
    setTotalPages, 
    setRowsPerPage 
} = generalBranchSlice.actions;

export default generalBranchSlice.reducer;
